import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import newGrad from '../../../js/pages/JobsListPage/newGradJobs';

const Page = () => <JobsListPage role={newGrad} />;

export default Page;
